import React, { useEffect } from "react";
import Modal from "../ui/Modal";
import Form, { FormField } from "../ui/Form";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as categoryActions from "src/redux/slices/categorySlice";
import { toast } from "react-toastify";

interface AddSubCategoryModalProps {
  open: boolean;
  parentCategoryId?: string | null;
  parentCategoryName?: string;
  subCategory?: any;
  onClose: () => void;
  onSuccess: () => void;
}

const AddSubCategoryModal: React.FC<AddSubCategoryModalProps> = ({
  open,
  parentCategoryId,
  parentCategoryName,
  subCategory = null,
  onClose,
  onSuccess,
}) => {
  const dispatch = useAppDispatch();
  const { editCategory } = useAppSelector((state) => state.category);

  useEffect(() => {
    if (editCategory.data) {
      toast.success("Subcategory updated successfully");
      handleClose();
    } else if (editCategory.error) {
      toast.error(`Error: ${editCategory.error}`);
    }
  }, [editCategory]);

  const handleClose = () => {
    dispatch(categoryActions.resetEditCategory());
    onSuccess();
  };

  const fields: FormField[] = [
    {
      label: "Subcategory Name",
      name: "name",
      type: "text",
      placeholder: "Enter subcategory name",
      validations: { required: true },
    },
    {
      label: "Description",
      name: "description",
      type: "text",
      placeholder: "Enter subcategory description",
    },
  ];

  const handleSubmit = (data: Record<string, any>) => {
    if (!parentCategoryId) {
      toast.error("Parent category is required for subcategory");
      return;
    }

    if (subCategory?._id) {
      dispatch(
        categoryActions.editCategoryRequest({
          _id: parentCategoryId,
          subCategoryUpdate: {
            _id: subCategory._id,
            name: data.name,
            description: data.description,
          },
        })
      );
      return;
    }

    dispatch(
      categoryActions.editCategoryRequest({
        _id: parentCategoryId,
        subCategory: {
          name: data.name,
          description: data.description,
        },
      })
    );
  };

  const modalTitle = subCategory?._id ? "Edit Subcategory" : "Add Subcategory";

  return (
    <Modal open={open} onClose={onClose} title={modalTitle}>
      {parentCategoryId && (
        <div className="mb-3 text-sm text-gray-600">
          Parent Category:{" "}
          <span className="font-semibold">
            {parentCategoryName || "Selected"}
          </span>
        </div>
      )}
      <Form
        initialState={subCategory as any}
        fields={fields}
        onSubmit={handleSubmit}
        onCancel={onClose}
        loading={editCategory.loading}
      />
    </Modal>
  );
};

export default AddSubCategoryModal;
